exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".adPlayer{position:absolute;top:0;left:0;width:100%;height:100%;z-index:1}.adPlayer:not(.active){visibility:hidden!important}.videoPlayer.debug .adPlayer{left:100%;visibility:visible!important}", ""]);

